import ScrollReveal from "./ScrollReveal";
import { BadgeEuro, Hammer, Zap, Thermometer, Palette } from "lucide-react";

const ADVANTAGES = [
  { icon: BadgeEuro, title: "-70%", desc: "Jusqu'à 70% moins cher qu'une cuisine neuve" },
  { icon: Hammer, title: "Zéro démolition", desc: "Pas de casse, pas de poussière, pas de stress" },
  { icon: Zap, title: "48h", desc: "Pose rapide en environ 2 jours" },
  { icon: Thermometer, title: "Résistant", desc: "Résistant chaleur et humidité au quotidien" },
  { icon: Palette, title: "Large choix", desc: "Finitions bois, marbre, mat, brillant et plus encore" },
];

export default function AdvantagesSection() {
  return (
    <section id="avantages" data-testid="advantages-section" className="py-24 lg:py-36 bg-[#0273DB]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <ScrollReveal>
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-white mb-4">
              Pourquoi choisir Vinylux ?
            </h2>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {ADVANTAGES.map((item, idx) => (
            <ScrollReveal key={item.title} delay={idx * 0.08}>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-7 border border-white/15 hover:-translate-y-1 hover:bg-white/15 transition-all duration-300 h-full">
                <div className="w-12 h-12 rounded-xl bg-white/15 flex items-center justify-center mb-4">
                  <item.icon className="w-6 h-6 text-white" />
                </div>
                <div className="font-heading font-black text-2xl text-white mb-2">
                  {item.title}
                </div>
                <p className="text-white/60 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
